angular.module('zc.projects')

.directive 'mainChart', ($filter, $location, $translate, AccessStats, Chart, SearchFilter, currencies, lib, mainChartItems) ->
  return {
    restrict: 'E'
    require: '?filters'
    templateUrl: '/templates/projects.analytics/views/directives/main_chart.html'
    scope:
      filters: '='
      project: '='
    link: (scope, element, attrs) ->
      scope.currency = currencies[scope.project.currency]
      scope.chartConfig = Chart.getChartConfig 'main'

      scope.mainChartItems = mainChartItems

      DEFAULT_ITEM = 0
      DEFAULT_DIMENSION = 'hourly'

      SearchFilter.setComponentDefaults('mainChart', {
        chart_item1:
          default: scope.mainChartItems[DEFAULT_ITEM].name,
          keyProperty: 'name',
          getter: (name) ->
            _.find(scope.mainChartItems, (d) -> d.name == name)
        chart_item2:
          default: undefined,
          keyProperty: 'name',
          getter: (name) ->
            _.find(scope.mainChartItems, (d) -> d.name == name)
        chart_dimension:
          default: DEFAULT_DIMENSION
      })

      scope.$on '$destroy', () ->
        SearchFilter.removeComponentDefaults('mainChart')

      scope.setDimension = (dimension) ->
        scope.filters.chart_dimension = dimension
        scope.update()

      addSeries = (type, item, i, data) ->
        Chart.addSeries scope.chartConfig,
          type: type
          name: item.label
          data: data
          tooltip: tooltip(item)
          yAxis: i

      addYAxis = (item, i) ->
        _tooltip = tooltip(item)
        scope.chartConfig.options.yAxis.push
          gridLineDashStyle: 'dot'
          min: 0
          labels:
            formatter: ->
              _tooltip.valuePrefix + Highcharts.numberFormat(this.value, _tooltip.valueDecimals) + _tooltip.valueSuffix
          title:
            text: item.label
          opposite: true if i is 1

      tooltip = (item) ->
        if item.name in ['average_conversion_price', 'conversion_price']
          valuePrefix: scope.currency.symbol
          valueSuffix: scope.currency.suffix
          valueDecimals: scope.currency.fractionSize
        else
          item.tooltip

      statsForChart = (access_stats) ->
        for stats in access_stats
          stats.conversion_rate = stats.conversion_rate * 100
          stats.cart_button_click_rate = stats.cart_button_click_rate * 100
          stats.average_dwell = stats.average_dwell / (1000 * 60)

          # currency is multiplied by a power of 10 that ensures the precision
          stats.average_conversion_price = stats.average_conversion_price / (10 ** scope.currency.fractionSize)
          stats.conversion_price = stats.conversion_price / (10 ** scope.currency.fractionSize)

        access_stats = $filter('zerosForMissingTime')(access_stats, scope.filters.chart_dimension, {
          start_at: scope.filters.start_at,
          end_at: scope.filters.end_at
        })
        access_stats

      ###
      NOTE: Need to make change to options for highcharts-ng to understand it
      Because of the stupid behavior of highcharts-ng,
      you need to make change to options even when series and axes change.
      see https://zenclerk.qiita.com/yujiosaka/items/d8a80106d5914eea6164
      ###
      refreshOptions = ->
        scope.chartConfig.options.rand = Math.random()

      scope.reset = ->
        # reset the search fields that this component is responsible of
        SearchFilter.resetComponentDefaults('mainChart')

      scope._update = ->
        # set and unset the fields that this component is responsible of
        SearchFilter.updateComponentDefaults('mainChart')

        paths =
          apikey: scope.project.apikey
          dimension: scope.filters.chart_dimension

        if scope.filters.chart_dimension in ['hourly', 'daily']
          AccessStats.findByFilter(paths, scope.filters).then (access_stats) ->
            access_stats = statsForChart access_stats
            scope.chartConfig.series = []
            scope.chartConfig.options.yAxis = []
            scope.chartConfig.options.xAxis =
              type: 'datetime'
              tickInterval: 24 * 3600 * 1000 if scope.filters.chart_dimension is "daily"
              dateTimeLabelFormats:
                hour: $translate.instant('sharedModules.dateTimeFormats.chart.hour')
                day: $translate.instant('sharedModules.dateTimeFormats.chart.monthDay')
            for item, i in [scope.filters.chart_item1_value, scope.filters.chart_item2_value]
              continue unless item
              data = ([stats.start_at.valueOf(), stats[item.name]] for stats in access_stats)
              addSeries 'line', item, i, data
              addYAxis item, i
              refreshOptions()

        else

          AccessStats.aggregateByFilter(paths, scope.filters).then (access_stats) ->
            access_stats = statsForChart access_stats
            categories = ($filter(_.camelCase scope.filters.chart_dimension)(stats[scope.filters.chart_dimension]) for stats in access_stats)
            scope.chartConfig.series = []
            scope.chartConfig.options.yAxis = []
            scope.chartConfig.options.xAxis = {categories}
            for item, i in [scope.filters.chart_item1_value, scope.filters.chart_item2_value]
              continue unless item
              data = (stats[item.name] for stats in access_stats)
              addSeries 'column', item, i, data
              addYAxis item, i
              refreshOptions()

      # Delay this a bit... multiple views are doing stuff on loading time
      # and everything might not be set yet...
      scope.update = _.debounce(scope._update, 500)

      scope.update()
      scope.$on 'filtersUpdated', scope.update
      scope.$on 'filtersReset', scope.reset
  }



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.analytics/directives/main_chart.js.coffee